import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UploadLinkFieldsFragment = { __typename?: 'UploadLink', id?: string | null, name?: string | null, url?: string | null, enabled?: boolean | null, passphrase?: string | null, expiresAt?: string | null, insertedAt?: string | null, updatedAt?: string | null, creator?: { __typename?: 'AuthenticatedUser', id: string, name?: string | null, profileImageUrl?: string | null } | null, folder?: { __typename?: 'FolderAsset', id: string, name: string, restricted?: boolean | null } | null, project?: { __typename?: 'Project', id: string, name: string } | null };

export const UploadLinkFields = /*#__PURE__*/ gql`
    fragment UploadLinkFields on UploadLink {
  id
  name
  url
  enabled
  passphrase
  expiresAt
  insertedAt
  updatedAt
  creator {
    id
    name
    profileImageUrl
  }
  folder {
    id
    name
    restricted
  }
  project {
    id
    name
  }
}
    ` as unknown as DocumentNode<UploadLinkFieldsFragment, unknown>;

        

        
export const useUploadLinkFieldsFragment = (
  input: string | Omit<UseFragmentOptions<UploadLinkFieldsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'UploadLink' } };
    return input;
  })();

  return useFragment<UploadLinkFieldsFragment>({
    fragment: UploadLinkFields,
    fragmentName: 'UploadLinkFields',
    ...options,
  });
};
  
        